export default __webpack_public_path__ + "static/media/background.53138f05.jpg";